import { NgModule } from '@angular/core';

import { NoSanitizePipe } from 'src/app/common/pipes/noSanitize/noSanitize.pipe';
import { AddCommaPipe } from './add-comma/add-comma.pipe';
import { FormatCategoriesPipe } from './format-categories/format-categories.pipe';
import { FormatDatePipe } from './format-date/format-date.pipe';
import { PluralStatisticsPipe } from './plural-statistics/plural-statistics.pipe';
import { ReplaceBrokenUrlsPipe } from './replace-broken-image-urls/replace-broken-image-urls.pipe';
import { RepresentList } from './represent-list/represent-list.pipe';

@NgModule({
  declarations: [
    FormatDatePipe,
    AddCommaPipe,
    NoSanitizePipe,
    PluralStatisticsPipe,
    ReplaceBrokenUrlsPipe,
    RepresentList,
    FormatCategoriesPipe,
  ],
  exports: [
    FormatDatePipe,
    AddCommaPipe,
    NoSanitizePipe,
    PluralStatisticsPipe,
    ReplaceBrokenUrlsPipe,
    RepresentList,
    FormatCategoriesPipe,
  ],
})
export class PipesModule {}
